import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, getCurrentInstance, computed } from 'vue';

import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { APP_CONFIRMATION_DIALOG_RESPONSES } from '@/components/dialogs/AppDialogs/app-confirmation-dialog.const.js';
import { useAccountEmailDomainActions, useAccountEmailDomainGetters } from '@/store-composables';
import ErrorHandlingService from '@/utils/error-handling-service';
import { VerificationEmailTypes } from '@/utils/transactional-emails.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReplyToTab',
  setup(__props) {

const { fetchReplyToEmails, deleteReplyToEmails } = useAccountEmailDomainActions();
const { useReplyToEmails } = useAccountEmailDomainGetters();
const toast = getCurrentInstance()?.proxy?.$toast || console;

const emailSearchInput = ref('');
const replyToEmails = computed(() => useReplyToEmails.value);
const tableItems = computed(() => replyToEmails.value.map((email) => ({ email })));
onMounted(async () => {
	await fetchReplyToEmails();
});

const deleteEmail = async (email: string) => {
	const res = await AppDialogManagerService.openConfirmationDialog({
		title: 'Delete email',
		description: `Are you sure you want to delete ${email}?`,
		yesText: 'Delete',
		noText: 'Cancel',
	});
	if (res === APP_CONFIRMATION_DIALOG_RESPONSES.YES) {
		try {
			await deleteReplyToEmails(email);
		} catch (e) {
			toast.error(`Failed to delete email, ${ErrorHandlingService.extractErrorMessage(e)}`);
		}
	}
};

async function addVerifiedReplyToEmail() {
	await AppDialogManagerService.openAddVerifiedEmailDialog({ typeToVerify: VerificationEmailTypes.REPLY_TO });
	fetchReplyToEmails(); // Refresh the list of reply-to emails, no need to await, just fetch the data in store
}

const tableHeaders = [
	{ text: 'Email', value: 'email' },
	{ text: '', value: 'actions' },
];
const loadingReplyToEmails = ref(false);

return { __sfc: true,fetchReplyToEmails, deleteReplyToEmails, useReplyToEmails, toast, emailSearchInput, replyToEmails, tableItems, deleteEmail, addVerifiedReplyToEmail, tableHeaders, loadingReplyToEmails }
}

})